import { render, staticRenderFns } from "./ExtendRoundButton.vue?vue&type=template&id=8d6e0afe&scoped=true&"
import script from "./ExtendRoundButton.vue?vue&type=script&lang=js&"
export * from "./ExtendRoundButton.vue?vue&type=script&lang=js&"
import style0 from "./ExtendRoundButton.vue?vue&type=style&index=0&id=8d6e0afe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6e0afe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
